module.exports = __webpack_public_path__ + "media/images/icon__search--rb-white-0c62eb75c8337012df7dda5e5340dce5.png";